<div class="user-list-card shadow-sm p-4 bg-white rounded">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="m-0 fw-bold text-dark">User List</h3>
    <div class="d-flex gap-2">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input 
          pInputText 
          type="text" 
          (input)="dt.filterGlobal($any($event.target).value, 'contains')" 
          placeholder="Search Users..." 
          class="p-inputtext-sm" />
      </span>
      <button class="btn btn-primary btn-sm px-3 rounded-0" (click)="showAddDialog()">
        <i class="pi pi-plus me-1"></i> Add User
      </button>
      <button class="btn btn-outline-secondary btn-sm px-3 rounded-0" (click)="loadUsers()">
        <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <p-table 
    #dt
    [value]="users" 
    [loading]="loading"
    [rows]="10" 
    [paginator]="true" 
    [responsiveLayout]="'scroll'"
    [globalFilterFields]="['username', 'email', 'firstName', 'lastName']"
    styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="username">Username <p-sortIcon field="username"></p-sortIcon></th>
        <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
        <th pSortableColumn="firstName">First Name <p-sortIcon field="firstName"></p-sortIcon></th>
        <th pSortableColumn="lastName">Last Name <p-sortIcon field="lastName"></p-sortIcon></th>
        <th>Roles</th>
        <th>Status</th>
        <th class="text-center">Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
      <tr>
        <td class="fw-medium">{{ user.username }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.firstName }}</td>
        <td>{{ user.lastName }}</td>
        <td>
          <div class="d-flex flex-wrap gap-1">
            <div *ngIf="user.roles && user.roles.length > 0; else noRoles">
              <p-tag 
                *ngFor="let role of user.roles" 
                [value]="role" 
                [rounded]="true" 
                class="role-tag-sm"
                title="Click to remove">
                <span class="ms-1 pointer x-small" (click)="removeRole(role, user)"><i class="pi pi-times"></i></span>
              </p-tag>
            </div>
            <ng-template #noRoles>
              <span class="text-muted x-small">No roles</span>
            </ng-template>
          </div>
        </td>
        <td>
          <p-tag 
            [severity]="user.enabled ? 'success' : 'danger'" 
            [value]="user.enabled ? 'Enabled' : 'Disabled'">
          </p-tag>
        </td>
        <td class="text-center">
          <div class="d-flex justify-content-center align-items-center gap-2">
            <p-inputSwitch 
              [(ngModel)]="user.enabled" 
              (onChange)="toggleUserStatus(user)">
            </p-inputSwitch>
            <button class="btn btn-outline-secondary btn-sm rounded-0 border-0" (click)="showUserDetails(user)" title="View Details">
              <i class="pi pi-eye"></i>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-0 border-0" (click)="editUser(user)" title="Edit">
              <i class="pi pi-pencil"></i>
            </button>
            <button class="btn btn-outline-info btn-sm rounded-0 border-0" (click)="resendVerificationEmail(user)" title="Resend Verification Email">
              <i class="pi pi-envelope"></i>
            </button>
            <button class="btn btn-outline-warning btn-sm rounded-0 border-0" (click)="manageRoles(user)" title="Manage Roles">
              <i class="pi pi-key"></i>
            </button>
            <button class="btn btn-outline-warning btn-sm rounded-0 border-0" (click)="resetPassword(user)" title="Reset Password">
              <i class="pi pi-lock"></i>
            </button>
            <button class="btn btn-outline-danger btn-sm rounded-0 border-0" (click)="confirmDelete(user)" title="Delete">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center py-4 text-muted">No users found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Edit User Dialog -->
<p-dialog 
  header="Edit User" 
  [(visible)]="displayEditDialog" 
  [modal]="true" 
  [style]="{width: '450px'}" 
  styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="field mb-3">
            <label for="username" class="fw-medium mb-1">Username</label>
            <input type="text" pInputText id="username" [(ngModel)]="editUserData.Username" required autofocus />
        </div>
        <div class="field mb-3">
            <label for="email" class="fw-medium mb-1">Email</label>
            <input type="email" pInputText id="email" [(ngModel)]="editUserData.Email" required />
        </div>
        <div class="field mb-3">
            <label for="firstName" class="fw-medium mb-1">First Name</label>
            <input type="text" pInputText id="firstName" [(ngModel)]="editUserData.FirstName" />
        </div>
        <div class="field mb-3">
            <label for="lastName" class="fw-medium mb-1">Last Name</label>
            <input type="text" pInputText id="lastName" [(ngModel)]="editUserData.LastName" />
        </div>
        <div class="field d-flex align-items-center gap-2">
            <label class="fw-medium m-0">Enabled</label>
            <p-inputSwitch [(ngModel)]="editUserData.Enabled"></p-inputSwitch>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" [text]="true" (onClick)="displayEditDialog = false"></p-button>
        <p-button label="Save" icon="pi pi-check" [loading]="saving" (onClick)="saveUser()"></p-button>
    </ng-template>
</p-dialog>

<!-- Manage Roles Dialog -->
<p-dialog 
  header="Manage User Roles" 
  [(visible)]="displayRolesDialog" 
  [modal]="true" 
  [style]="{width: '500px'}" 
  styleClass="p-fluid">
    <div *ngIf="selectedUser">
        <div class="mb-4">
            <p class="m-0 text-muted small">User</p>
            <h5 class="m-0 fw-bold">{{ selectedUser.username }}</h5>
        </div>

        <div class="field mb-3">
            <label class="fw-medium mb-1">Select Client</label>
            <div class="d-flex gap-2">
                <div *ngFor="let type of projectTypes" class="flex-grow-1">
                    <button 
                        class="btn btn-sm w-100 rounded-0" 
                        [class.btn-primary]="selectedClient === type.value"
                        [class.btn-outline-secondary]="selectedClient !== type.value"
                        (click)="selectedClient = type.value; loadAvailableRoles(); loadUserRoles()">
                        {{ type.label }}
                    </button>
                </div>
            </div>
        </div>

        <div class="field mb-3">
            <label class="fw-medium mb-1">Current Roles ({{selectedClient}})</label>
            <div class="d-flex flex-wrap gap-2 p-2 bg-light border rounded" style="min-height: 50px;">
                <div *ngIf="userRoles.length === 0" class="text-muted small">No roles assigned.</div>
                <p-tag *ngFor="let role of userRoles" [value]="role" [rounded]="true" class="role-tag">
                    <span class="ms-2 pointer" (click)="removeRole(role)"><i class="pi pi-times-circle"></i></span>
                </p-tag>
            </div>
        </div>

        <div class="field">
            <label class="fw-medium mb-1">Assign New Roles</label>
            <p-multiSelect 
                [options]="availableRoles" 
                [(ngModel)]="newRolesToAssign" 
                optionLabel="label" 
                optionValue="value"
                placeholder="Select Roles" 
                display="chip">
            </p-multiSelect>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Close" icon="pi pi-times" [text]="true" (onClick)="displayRolesDialog = false"></p-button>
        <p-button label="Update Roles" icon="pi pi-check" [loading]="saving" (onClick)="saveRoles()"></p-button>
    </ng-template>
</p-dialog>

<!-- Delete Confirmation -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- Add User Dialog -->
<p-dialog 
  header="Add New User" 
  [(visible)]="displayAddDialog" 
  [modal]="true" 
  [style]="{width: '450px'}" 
  styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="field mb-3">
            <label for="new_username" class="fw-medium mb-1">Username</label>
            <input type="text" pInputText id="new_username" [(ngModel)]="addUserData.username" required autofocus />
        </div>
        <div class="field mb-3">
            <label for="new_email" class="fw-medium mb-1">Email</label>
            <input type="email" pInputText id="new_email" [(ngModel)]="addUserData.email" required />
        </div>
        <div class="field mb-3">
            <label for="new_firstName" class="fw-medium mb-1">First Name</label>
            <input type="text" pInputText id="new_firstName" [(ngModel)]="addUserData.firstName" />
        </div>
        <div class="field mb-3">
            <label for="new_lastName" class="fw-medium mb-1">Last Name</label>
            <input type="text" pInputText id="new_lastName" [(ngModel)]="addUserData.lastName" />
        </div>
        <div class="field mb-3">
            <label for="region" class="fw-medium mb-1">Region</label>
            <p-dropdown [options]="regions" [(ngModel)]="addUserData.region" optionLabel="label" optionValue="value" placeholder="Select Region"></p-dropdown>
        </div>
        <div class="field d-flex align-items-center gap-4">
            <div class="d-flex align-items-center gap-2">
                <label class="fw-medium m-0">Active</label>
                <p-inputSwitch [(ngModel)]="addUserData.isActive"></p-inputSwitch>
            </div>
            <div class="d-flex align-items-center gap-2">
                <label class="fw-medium m-0">Send Email</label>
                <p-inputSwitch [(ngModel)]="addUserData.sendActivationEmail"></p-inputSwitch>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" [text]="true" (onClick)="displayAddDialog = false"></p-button>
        <p-button label="Create User" icon="pi pi-check" [loading]="saving" (onClick)="saveNewUser()"></p-button>
    </ng-template>
</p-dialog>

<!-- View User Details Dialog -->
<p-dialog 
  header="User Details" 
  [(visible)]="displayDetailDialog" 
  [modal]="true" 
  [style]="{width: '500px'}" 
  styleClass="p-fluid detail-dialog">
    <div *ngIf="userDetails; else loadingDetails">
        <div class="user-detail-header text-center mb-4">
            <div class="user-avatar-circle mx-auto mb-3">
                <i class="pi pi-user text-primary" style="font-size: 2.5rem;"></i>
            </div>
            <h4 class="m-0 fw-bold">{{ userDetails.firstName }} {{ userDetails.lastName }}</h4>
            <p class="text-muted m-0">&#64;{{ userDetails.username }}</p>
        </div>

        <div class="detail-grid">
            <div class="detail-item mb-3">
                <label class="text-muted small fw-bold text-uppercase d-block mb-1">Email Address</label>
                <div class="d-flex align-items-center gap-2">
                    <span class="fw-medium">{{ userDetails.email }}</span>
                    <p-tag 
                        [severity]="userDetails.emailVerified ? 'success' : 'warning'" 
                        [value]="userDetails.emailVerified ? 'Verified' : 'Unverified'"
                        [rounded]="true"
                        class="detail-tag-xs">
                    </p-tag>
                </div>
            </div>

            <div class="row">
                <div class="col-6 mb-3">
                    <label class="text-muted small fw-bold text-uppercase d-block mb-1">Status</label>
                    <p-tag 
                        [severity]="userDetails.enabled ? 'success' : 'danger'" 
                        [value]="userDetails.enabled ? 'Account Active' : 'Account Disabled'">
                    </p-tag>
                </div>
                <div class="col-6 mb-3">
                    <label class="text-muted small fw-bold text-uppercase d-block mb-1">Last Login</label>
                    <span class="fw-medium text-dark">{{ userDetails.lastLogin ? (userDetails.lastLogin | date:'medium') : 'Never' }}</span>
                </div>
            </div>

            <div class="detail-item mb-3" *ngIf="userDetails.roles && userDetails.roles.length > 0">
                <label class="text-muted small fw-bold text-uppercase d-block mb-1">Assigned Roles</label>
                <div class="d-flex flex-wrap gap-1 mt-1">
                    <p-tag *ngFor="let role of userDetails.roles" [value]="role" [rounded]="true" severity="info"></p-tag>
                </div>
            </div>
            
            <div class="detail-item mb-2">
                <label class="text-muted small fw-bold text-uppercase d-block mb-1">User ID</label>
                <code class="small text-break">{{ userDetails.id }}</code>
            </div>
        </div>
    </div>

    <ng-template #loadingDetails>
        <div class="text-center p-5">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            <p class="mt-2">Loading user details...</p>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Close" icon="pi pi-times" (onClick)="displayDetailDialog = false"></p-button>
    </ng-template>
</p-dialog>

<p-toast></p-toast>
